import React, { ComponentProps } from 'react';
import { cn } from '@/utils/styles';
import Card from './Card';

interface MediaContainerProps extends ComponentProps<typeof Card> {
  className?: string;
  children?: React.ReactNode;
  border?: boolean;
}

const MediaContainer = ({ className, ...props }: MediaContainerProps) => {
  return (
    <Card
      className={cn('overflow-hidden bg-transparent', className)}
      {...props}
    />
  );
};

export default MediaContainer;
